<template>
  <div>
    <slot name="header"></slot>
    <slot name="hero"></slot>
    <div class="template-2-breadcrumb">
      <slot name="breadcrumb"></slot>
    </div>
    <div class="course-tile-list-v2-wrapper h-screen">
      <div
        class="template-two-container flex md:flex-row flex-col md:space-x-5"
      >
        <slot
          v-if="courseSettings.sidebar_position == 2"
          name="right-sidebar"
        ></slot>
        <slot name="course"></slot>
        <slot
          v-if="courseSettings.sidebar_position == 1"
          name="right-sidebar"
        ></slot>
      </div>
    </div>
    <slot name="footer"></slot>
  </div>
</template>
<script>
export default {
  name: 'WelcomeMarkup',
  data() {
    return {};
  },
  props: {
    courseSettings: {},
  },
};
</script>
<style lang="scss">
.template-two-container {
  max-width: 1130px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px;
  .md\:w-8\/12 {
    width: 66.666667%;
  }
  .md\:w-4\/12 {
    width: 36.333333%;
  }
  .shadow-lg {
    box-shadow: 20px 20px 40px rgba(22, 29, 37, 0.05);
  }
  .rounded-lg {
    border-radius: 10px;
  }
}

//css for tablet welcome page template 2

.tablet-template,
.mobile-template {
  .template-two-container {
    flex-direction: column;
    display: flex;
    .md\:w-8\/12 {
      width: 100%;
      order: 1;
    }
    .md\:w-4\/12 {
      width: 100%;
      order: 0;
      margin-left: 0px;
    }
  }
}
@media only screen and (max-width: 767px) {
  .course-tile-list-v2-wrapper {
    .template-two-container {
      .md\:w-8\/12 {
        width: 100%;
        order: 1;
      }
      .md\:w-4\/12 {
        width: 100%;
        order: 0;
        margin-left: 0px;
      }
    }
  }
  .h-screen {
    height: auto;
  }
}
.bg-tile-red {
  background: #ec745f;
}
.bg-light-grey {
  background: #e3e3e3;
}
.membership-template-builder .h-screen,
.course-tile-list-v2-wrapper.h-screen {
  height: 100%;
}
@media only screen and (min-width: 1700px) {
  .membership-template-builder .h-screen,
  .course-tile-list-v2-wrapper.h-screen {
    min-height: 83vh;
  }
}
</style>